module.exports = __webpack_public_path__ + "img/character-generator.e6d7ef06.gif";